<template>
  <!-- 藏品专题详情 -->
  <div class="page-collect-topic-detail">
    <div class="m-banner-top">
      <div class="top-box">
        <div class="pic-box" @contextmenu.prevent>
          <img v-lazy="detailData.materialPicture">
        </div>

        <div class="label-box">
          <h1 class="tc mb-20">{{detailData.name}}</h1>
          <div class="dec-line"></div>
          <!-- <p class="price"><span><i>¥ </i>{{detailData.price}}</span></p> -->
          <div class="txt">
            <label>素材来源：</label>
            <span>{{detailData.sourceName}}</span>
          </div>
          <div class="txt">
            <label>素材编号：</label>
            <span>{{detailData.code}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="g-content-wrap">
      <!-- <div class="slides-box">
        <div class="pic-box">
          <img v-lazy="detailData.attId" alt="">
        </div>
        <div class="pic-info g-border-box trans">
          <div class="g-border">
            <h2 class="title">{{detailData.title}}</h2>
            <p>规格：{{detailData.ext1}}</p>
            <p>类别：{{typeChinese(detailData.typeId) || ''}}</p>
            <p class="price">价格：<span style="font-size:30px"><i style="font-size:16px;">¥ </i>{{detailData.price}}</span></p>

            <div class="btn-box mt-40" v-if="detailData.url">
              <a class="g-btn-level-1" :href="detailData.url" target="_blank">立即购买</a>
            </div>
          </div>
        </div>
      </div> -->

      <div class="content">
        <h2 class="title">
          <img src="~@images/material/title_01.png" alt="">
        </h2>
        <div class="g-detail-html trans">
          <p class="indent">本素材库提供的数字资源（素材）和服务中包含的任何文本、图片、图形、音频、设计素材和/或视频资料均受著作权法、商标法和/或其它财产所有权范围的法律的保护，除本素材库特别标注外，其知识产权、所有权及相关权利均由敦煌研究院享有。未经辽宁省博物馆书面授权，任何用户不得将本素材库中的任何资源、内容等用于其他任何用途。</p>
          <p class="indent">您可以按照自己的用户权限访问、查阅、下载和使用本素材库中的资源，但辽宁省博物馆对您的使用授权仅限于您与辽宁省博物馆签订的服务协议、授权协议等书面约定以及按合同性质、目的、交易习惯以及诚信原则正当合理地自用目的。未经辽宁省博物馆书面许可，您不得超出用户权限和正当合理自用目的使用，否则，敦煌研究院有权向您追究相应法律责任。</p>
          <p class="indent">您在使用本素材库的产品和服务过程中，未经辽宁省博物馆书面授权，不得有包括但不限于以下的非法使用行为：</p>
          <p>1、擅自超出用户权限和正当合理自用目的，以复制、转让、提供、出售、发布、传播、展示、镜像、上传、下载、友情链接等方式非法使用或让第三方非法使用；</p>
          <p>2、通过非常规方式恶意影响本素材库的正常产品功能和服务；</p>
          <p>3、以任何方式恶意注册、发布、传播、盗用、售卖、租赁本素材库相关产品、账号、内容和服务以牟取非法利益的；</p>
          <p>4、使用任何自动或手动的流程、抓取设备、程序、算法或方法等敦煌研究院未对外提供的方式访问、试图获取、获取、拷贝或监控本素材库的任何内容。</p>
        </div>

        <h2 class="title">
          <img src="~@images/material/title_02.png" alt="">
        </h2>
        <div class="g-detail-html trans">
          <p class="indent">本平台免费下载的资源，仅供个人欣赏、学习、研究时使用，下载后使用时间不得超过30个自然日。如需将下载的任何资源通过包括但不限于社交网络媒体（微博、微信、自媒体）、网站、APP、书籍、报纸、期刊、电视节目、电影作品、展览、装修装饰、包装设计、广告、公关活动、宣传图册、PPT演示等途径用于任何其他用途，请联系本网站获得授权后再行使用。</p>
        </div>
        <!-- <div class="g-detail-html trans" v-html="detailData.subject"></div> -->
      </div>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detailId: this.$route.query.id,
      detailData: {
        content: ''
      },
      typeList: [],
    }
  },
  methods: {
    getDetailData() {
      this.$http
        .get('../singleMuseum/webapi/collectmaterial/detail', {
          id: this.detailId
        })
        .then(res => {
          if (res.success) {
            this.detailData = res.result
          } else {
            this.$message.error(res.message)
          }
        })
    },
    getDictData() {
      this.$http
        .get('../singleMuseum/collectDict/getSelectDataByKey?key=cc_type', {
        }).then(res => {
          if (res.success) {
            this.typeList = res.result

            this.getDetailData()
          } else {
            this.$message.error(res.message)
          }
        })
    },
    typeChinese(typeId){
      let dictName
      this.typeList.map(item => {
        if(item.dictCode === typeId){
          dictName = item.dictName
        }
      })
      return dictName
    }
  },
  created() {
    // this.getDictData()
    this.getDetailData()
  }
}
</script>

<style lang="scss" scoped>
.page-collect-topic-detail {
  
  .top-box {
    .pic-box {
      margin-left: 0;
      width: 884px;
      height: 675px;
      padding: 60px 85px 70px 70px;
      box-sizing: border-box;
      background: url(~@images/material/bg_sucai.png) no-repeat;
      background-size: 100% 100%;
    }
    .label-box {
      margin-left: -50px;
      width: 775px;
      height: 590px;
      padding: 60px 140px 70px 50px;
      box-sizing: border-box;
      background: url(~@images/material/sucai_rigjt.png) no-repeat;
      background-size: 100% 100%;
      h1 {
        margin-top: 30px;
        margin-bottom: 30px;
      }
      .dec-line {
        margin-bottom: 50px;
        width: 100%;
        height: 18px;
        background: url(~@images/material/line.png) no-repeat;
        background-size: cover;
      }
      .txt {
        display: flex;
        flex-direction: column;
        font-size: 28px;
        color: #362818;
        margin-bottom: 50px;
        label {
          margin-bottom: 10px;
          font-size: 24px;
          color: #4B351A;
          opacity: .7;
        }
      }
    }
  }

  .m-banner-top {
    padding-top: 120px;
    box-sizing: border-box;
    position: relative;
    top: -83px;
    height: 900px;
    background: url(~@images/material/bg01.png);
    background-size: cover;
  }

  .g-content-wrap {
    margin-top: -83px;
    width: 100%;
    background: url(~@images/material/bg_02.png) no-repeat right center;
    background-size: cover;
    .content {
      width: 1200px;
      margin: 0 auto;
      .title {
        padding: 70px 0 50px;
        text-align: center;
        img {
          height: 114px;
        }
      }
      .g-detail-html {
        p {
          font-size: 20px;
          color: #000000;
          line-height: 36px;
          &.indent {
            text-indent: 2em;
          }
        }
      }
    }

  }
}
</style>

